import { render, staticRenderFns } from "./Microsite.vue?vue&type=template&id=8f199936&scoped=true"
import script from "./Microsite.vue?vue&type=script&lang=js"
export * from "./Microsite.vue?vue&type=script&lang=js"
import style0 from "./Microsite.vue?vue&type=style&index=0&id=8f199936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.93.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f199936",
  null
  
)

export default component.exports